import { Button } from 'antd';
import Modal from 'components/Modal';
import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {Modal as AntModal} from 'antd';
const { confirm } = AntModal;

const CloseAllAlarmsModal = ({ 
  visible,
  closeModal,
  alarmsCount,
  closeAllAlarms,
  closeAllAlarmsByWellId,
  executeTrendAnalysis,
  executeTrendAnalysisByWell,
  wellName }) => {

  const showDeleteAllAlarmsConfirm = () => {
    confirm({
      title: 'Закрыть все предупреждения в системе?',
      icon: <ExclamationCircleOutlined />,
      okText: 'ДА',
      okType: 'danger',
      cancelText: 'НЕТ',
      onOk() {
        closeAllAlarms();
      },
      onCancel() {
      },
    });
  };

  const showDeleteAllAlarmsByWellIdConfirm = () => {
    confirm({
      title: `Закрыть все предупреждения по скважине ${wellName} ?`,
      icon: <ExclamationCircleOutlined />,
      content: `Будет закрыто предупреждений (${alarmsCount})`,
      okText: 'ДА',
      okType: 'danger',
      cancelText: 'НЕТ',
      onOk() {
        closeAllAlarmsByWellId();
      },
      onCancel() {
      },
    });
  };

  const showExecuteTrendAnalysisByWell = () => {
    confirm({
      title: `Запустить Трендовый анализ по скважине ${wellName}?`,
      icon: <ExclamationCircleOutlined />,
      okText: 'ДА',
      okType: 'danger',
      cancelText: 'НЕТ',
      onOk() {
        executeTrendAnalysisByWell();
      },
      onCancel() {
      },
    });
  }


  const showExecuteTrendAnalysis = () => {
    confirm({
      title: `Запустить Трендовый анализ по всем скважинам?`,
      icon: <ExclamationCircleOutlined />,
      okText: 'ДА',
      okType: 'danger',
      cancelText: 'НЕТ',
      onOk() {
        executeTrendAnalysis();
      },
      onCancel() {
      },
    });
  }

  return (
    <Modal
      width="650px"
      title="Выберите действие"
      visible={visible}
      onCancel={() => {
        closeModal();
      }}
      footer={false}
      className="add-priority-modal"
    >
      <div style={{ height: "350px", paddingLeft: "50px" }}>
        <p style={{ fontSize: '16px', fontWeight: 'bold' }}>Закрыть предупреждения</p>
        <Button style={{ width: "550px" }} disabled={!alarmsCount} onClick={showDeleteAllAlarmsByWellIdConfirm} danger>{`Закрыть предупреждения по скважине  ${wellName}`}</Button>
        <br />
        <br />
        <Button style={{ width: "550px" }} onClick={showDeleteAllAlarmsConfirm} type="primary" danger>
          Закрыть все предупреждения в системе
        </Button>
        <br />
        <br />
        <p style={{ fontSize: '16px', fontWeight: 'bold' }}>Запустить трендовый анализ</p>
        <Button style={{ width: "550px" }} onClick={showExecuteTrendAnalysisByWell} type="primary" ghost>
          {`Запустить Трендовый анализ по скважине ${wellName}`}
        </Button>
        <br />
        <br />
        <Button style={{ width: "550px" }} onClick={showExecuteTrendAnalysis} type="primary">
          {`Запустить Трендовый анализ по всем скважинам`}
        </Button>
      </div>
    </Modal>
  );
};
export default CloseAllAlarmsModal;